<mat-card class="ui-wrapper">
  <div class="d-flex">
    <div class="pe-5">
      @if (order) {
        <mat-card-title>
          Order #{{order.id}}
        </mat-card-title>
      }
      @if (order) {
        <mat-card-subtitle>
          {{order.status.status}}
        </mat-card-subtitle>
      }
    </div>

    @if (company && individual) {
      <div class="me-2">
        <mat-card-title> {{company.name}} </mat-card-title>
        <mat-card-subtitle>
          {{ company.phone_number + (company.phone_number_alt ? " / " + company.phone_number_alt : "
          ") }}
        </mat-card-subtitle>
      </div>
    }

    @if (individual && !company) {
      <div class="me-2">
        <mat-card-title> {{individual.first_name + ' ' + individual.last_name}} </mat-card-title>
        <mat-card-subtitle>
          {{ individual.phone_number + (individual.phone_number_alt ? " / " +
          individual.phone_number_alt
          : "
          ") }}
        </mat-card-subtitle>
      </div>
    }
  </div>
  <div class="mt-3">
    <mat-accordion multi="true">
      <mat-expansion-panel expanded="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h3 class="font-weight-bold">Not scanned</h3>
          </mat-panel-title>
          <mat-panel-description>
            These items need to be scanned
          </mat-panel-description>
        </mat-expansion-panel-header>
        <core-order-item-fulfilment-list [items]="unscannedFulfilmentItems"
          [displayedColumns]="unScannedFulfilmentItemsDisplayedColumns">
        </core-order-item-fulfilment-list>
      </mat-expansion-panel>
      <mat-expansion-panel expanded="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h3 class="font-weight-bold">Scanned</h3>
          </mat-panel-title>
          <mat-panel-description>
            These items have been scanned
          </mat-panel-description>
        </mat-expansion-panel-header>
        <core-order-item-fulfilment-list [items]="scannedFulfilmentItems"
        [displayedColumns]="scannedFulfilmentItemsDisplayedColumns"></core-order-item-fulfilment-list>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
  <mat-card-actions align="end">
    @if (order) {
      <button (click)="gotoPrescriptionReview()" [routerLink]="['/portal/prescriptions/review', order.id]"
        mat-raised-button color="primary">
        <mat-icon>done</mat-icon> Done
      </button>
    }
  </mat-card-actions>
</mat-card>